import { UsersService } from '@/services/users.service';
import Vue from 'vue';
import { setActiveStudent as setLeaseActiveStudent } from '@/services/leaseService';

export default {
  namespaced: true,
  state: {
    currentUser: {
      // profile
      taxId:'',
      birthDate: (new Date()),
      phones: [],
      studentPhoto: '',
      // jwt
      studentId: "",
      name: "",
      email: "",
      iat: 0,
      nbf: 0,
      exp: 0,
      layoutTheme: 'dark'
    }
  },
  getters: {
    currentProfile: state => {

      return Object.assign({}, state.currentUser);
    },
    currentProfileFirstLetter: state => {
      return state.name ? state.name.substr(0,1).toUpperCase() : '';
    }
  },
  actions: {
    async updateProfilePic({ commit }){

      var imageName = this.state.user.currentUser.email;
      imageName = imageName.split("@").join("_").split(".").join("_") + ".jpg"; // filename
      imageName = 'marketplace/users/' + imageName;

      const fullImageName = process.env.VUE_APP_CDN_URL + imageName;
      var response = fetch(fullImageName).then(response =>{
        var profilePic = response.ok ? fullImageName : "";
        commit('SET_CURRENT_USER_PIC', profilePic);
      }).catch(error=>{
        commit('SET_CURRENT_USER_PIC', "");
      });
    },

    getCurrent ({ commit }) {
      // Sem access token NENHUM (ex.: janela do relogin biométrico) → não busca.
      // NÃO usar isAccessTokenLocallyValid aqui: ela compara o `exp` do JWT com o
      // relógio DO CLIENTE, e um relógio adiantado (Story-5449: +3h52 num aluno)
      // faria este guard pular o GET /students para sempre — currentUser.email
      // ficava vazio e o player chamava vdplayer `/users//check` (404, loading
      // infinito). Token presente-mas-expirado segue: o interceptor renova no 401.
      // require lazy: evita ciclo de init (módulo do store ↔ auth.service).
      let AuthSvc = null;
      try { AuthSvc = require('@/services/auth.service').AuthService; } catch {}
      // Fail-open consciente: se o ciclo de init deixar o export incompleto o
      // guard evapora — registra em vez de sumir em silêncio.
      if (!AuthSvc) console.warn('[user/getCurrent] auth.service indisponível — guard de token pulado');
      else if (!AuthSvc.hasAccessToken()) return Promise.resolve();
      return UsersService.getCurrent()
        .then(user => commit('SET_CURRENT_USER', user.data))
        .catch(error => commit('toast/NEW', { type: 'error', message: error.message, suppressOffline: true }, { root: true }))
    },

    updateProfile({commit}, userObj) {
      return UsersService.updateProfile(userObj.name, userObj.email, userObj.taxId, userObj.birthDate, userObj.phones)
        .then(responseData => {
          this.dispatch('user/getCurrent')
            .then(reloaded => { })
            .catch(error => commit('toast/NEW', { type: 'error', message: error.message, suppressOffline: true }, { root: true }));
          return responseData;
        })
        .catch(error => commit('toast/NEW', { type: 'error', message: error.message, suppressOffline: true }, { root: true }))
    },

    changePassword({commit}, changePassword){
      return UsersService.changePassword(changePassword.email, changePassword.current, changePassword.new)
        .then((response) => {
          return (response != null && response.status == 200);
        })
        .catch(error => {
          if(error.status == 304)
            commit('toast/NEW', { type: 'error', message: 'A senha atual não confere', suppressOffline: true }, { root: true });
          else
            commit('toast/NEW', { type: 'error', message: error.message, suppressOffline: true }, { root: true });
        });
    },

    updateTelegramId({commit}, telegramId) {
      return UsersService.updateTelegramId(telegramId)
        .then((response) => {
          return (response != null && response.status == 200);
        })
        .catch(error => {
          commit('toast/NEW', { type: 'error', message: error.message, suppressOffline: true }, { root: true });
        });
    },

    setCurrentTheme({commit}, selectedTheme) {
      commit('SET_CURRENT_THEME', selectedTheme);
    }
  },
  mutations: {
    SET_CURRENT_USER (state, currentUserData) {
      const prevStudentId = state.currentUser && state.currentUser.studentId;
      Vue.set(state, 'currentUser', currentUserData);
      const newStudentId = currentUserData && currentUserData.studentId;
      // require lazy do store: import estático aqui criaria ciclo de init (módulo
      // do store importando o próprio store).
      const getStore = () => { try { return require('@/store').default; } catch { return null; } };
      // Persiste para uso offline (só quando tem dados reais)
      if (newStudentId) {
        try {
          localStorage.setItem('ead_cached_user', JSON.stringify(currentUserData));
        } catch {}
        // Propaga pro nativo (RAM only) — usado pelo VxlKeySchemeHandler pra
        // verificar que o studentId do lease bate com quem está logado. Sem
        // isso, scheme handler bloqueia playback até o JS rehidratar. Async
        // fire-and-forget; bridge é idempotente.
        setLeaseActiveStudent(newStudentId).catch(() => {});
        // Troca de identidade (login / outra conta) → rehidrata o cache JS de
        // lease a partir dos arquivos nativos. Cobre re-login na MESMA sessão
        // (onde o boot não roda) — sem isso playableState fica 'unknown' até a
        // próxima navegação online.
        if (newStudentId !== prevStudentId) {
          const s = getStore(); if (s) s.dispatch('lease/hydrateFromNative').catch(() => {});
        }
      } else {
        // Logout / clear → zera no nativo.
        setLeaseActiveStudent(null).catch(() => {});
        // E limpa o cache JS de lease (NÃO os arquivos nativos) pra não vazar o
        // estado de leases entre contas no mesmo device. Re-login da conta
        // original segue funcionando (studentId bate + rehydrate acima).
        if (prevStudentId) {
          const s = getStore(); if (s) s.dispatch('lease/clearCache').catch(() => {});
        }
      }
    },
    SET_ENROLL(state, enroll){
      state.selectedEroll = enroll;
    },
    SET_LEARNING_OBJECT (state, data) {
      state.selectedLearningObject = data
    },
    SET_CURRENT_USER_PIC(state, data){
      state.currentUser.studentPhoto = data;
    },
    SET_CURRENT_THEME(state, data) {
      Vue.set(state.currentUser, 'layoutTheme', data);
    }
  }
}
